// extracted by mini-css-extract-plugin
export default {"root":"FlightHit__root--tuUBS","fadeIn":"FlightHit__fadeIn--YeNo5","container":"FlightHit__container--KoR9l"};